import React from "react";
import Section7Data from "../section7Data/section7Data";
import "./sectionSeven.css";

const SectionSeven = () => {
  return (
    <div className="sectionSeven-main-wrapper">
      <div className="sectionSeven-inner-wrapper">
        <div>
          <h1 className="future-heading-container">FUTURE COLLECTIONS</h1>
          <Section7Data
            section7ItemHeading={"Collection Name"}
            bgColor={"#FAD867"}
            section7Data1={"Buff Potatoes"}
            section7Data2={"Buff Potatoes"}
            section7Data3={"3D Potatoes"}
            bdColor={"1px solid #FAD867"}
          />
          <Section7Data
            section7ItemHeading={"Launch Date"}
            bgColor={"#A1BFDD"}
            section7Data1={"Q3 2022"}
            section7Data2={"Q4 2022"}
            section7Data3={"Q1 2023"}
            bdColor={"1px solid #A1BFDD"}
          />
          <Section7Data
            section7ItemHeading={"How It will Work"}
            bgColor={"#BFDDB6"}
            section7Data1={
              "Surprise! Details will be announced closer to launch date in our Discord"
            }
            section7Data2={
              "Surprise! Details will be announced closer to launch date in our Discord"
            }
            section7Data3={
              "Surprise! Details will be announced closer to launch date in our Discord"
            }
            bdColor={"1px solid #BFDDB6"}
          />
          <Section7Data
            section7ItemHeading={"Free for Holders?"}
            bgColor={"#BEA2FD"}
            section7Data1={"Yes, gas fees only"}
            section7Data2={"Yes, gas fees only"}
            section7Data3={"Yes, gas fees only"}
            bdColor={"1px solid #BEA2FD"}
          />
          <Section7Data
            section7ItemHeading={"Price"}
            bgColor={"#FFAB91"}
            section7Data1={"Same as original mint price for Party Potato Club"}
            section7Data2={"Same as original mint price for Party Potato Club"}
            section7Data3={"Same as original mint price for Party Potato Club"}
            bdColor={"1px solid #FFAB91"}
          />
        </div>
      </div>
    </div>
  );
};

export default SectionSeven;
